import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: true
})
export class OrderByPipe implements PipeTransform {
  transform<T>(array: T[], field: keyof T): T[] {
    if (!Array.isArray(array)) return array;
    return [...array].sort((a, b) => {
      const valA = (a as any)[field];
      const valB = (b as any)[field];
      if (valA == null) return -1;
      if (valB == null) return 1;
      return valA < valB ? -1 : valA > valB ? 1 : 0;
    });
  }
}

